module.exports = __webpack_public_path__ + "assets/images/isi_button_pause_mob.png";